import { InputAdornment } from '@mui/material';
import { TextField } from '@mui/material'
import React from 'react'

const Input = (props) => {
    const {
        value,
        placeholder = "",
        onChange,
        label,
        error,
        multiline = false,
        rows = 5,
        type = "text",
        variant = "outlined",
        endAdornment = false,
        startAdornment = false,
        startAdornmentIcon = null,
        endAdornmentIcon = null,
        regex = null,
    } = props

    const material = {
        background: "#1A1A1A",
        width: "100%",
        color: "white",
        '& input::placeholder': {
            color: "white"
        },
        '& label.Mui-focused': {
            color: '#FF5500'
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FF5500' 
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: 0,
            color: "white",
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: "rgba(255, 85, 0, .3)"
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: "rgba(255, 85, 0, .6)"
        },
        '& .MuiFormHelperText-root.Mui-error': {
            margin: 0,
            marginTop: "10px",
        },
        '& .MuiInputLabel-root': {
            color: "gray"
        }
    }

    const handleChange = (e) => {
        if(regex === "number") {
            const onlyNums = e.target.value.replace(/[^0-9]/g, '');
            onChange(onlyNums)
        }else {
            onChange(e.target.value)
        }
    }

    return (
        <TextField
            value={value}
            placeholder={placeholder}
            helperText={error ? error.message : null}
            onChange={handleChange}
            label={label}
            error={!!error}
            sx={material}
            multiline={multiline}
            rows={rows}
            type={type}
            variant={variant}
            InputProps={{
                startAdornment: startAdornment && (
                    <InputAdornment position='start' style={{ width: "fit-content", marginRight: "10px", color: "white" }}>
                        {startAdornmentIcon}
                    </InputAdornment>
                ),
                endAdornment: endAdornment && (
                    <InputAdornment position='end' style={{ width: "fit-content", marginRight: "10px" }}>
                        {endAdornmentIcon}
                    </InputAdornment>
                )
            }}
        />
    )
}

export default Input